export default {"src":"https://images-cdn.curipod.com/d-8a4f32ab/_next/static/media/bground.4c7c3901.svg","height":1908,"width":2989};